<div class="modal-header">
    <h4 class="modal-title">Ændringer i tilknytning til sager</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Handling</th>
            <th scope="col">Kundenr</th>
            <th scope="col">Navn</th>
            <th scope="col">Sag</th>
            <th scope="col">Udført af</th>
            <th scope="col">Set</th>
        </thead>
        <tbody>
            <tr *ngFor="let popup of popups; index as i">
                <td>{{
                    popup?.ptype === "unBlocked" ? "Spærring ophævet" :
                    popup?.ptype === "Blocked" ? "Spærret" :
                    popup?.ptype === "sag" ? "Sagsansvarlig" : ""
                }}</td>
                <td>{{popup.glkundenr}}</td>
                <td>{{popup.navn1}}</td>
                <td>{{popup.beskrivelse}}</td>
                <td>{{popup.cb}}</td>
                <td><button class="btn btn-sm btn-primary" (click)="onUpdateSeen($event, popup)">Set</button></td>
            </tr>
        </tbody>
    </table>
</div>
